import * as THREE from 'three'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader'
import { MTLLoader } from 'three/examples/jsm/loaders/MTLLoader'

const material = new THREE.MeshPhongMaterial({ color: 0xFEFEFE, wireframe: true })

export const loader = {
    gltf: ( url: string, callback: Function ) => {
        const loader = new GLTFLoader()
        console.log(loader)
        // const dracoLoader = new DRACOLoader();
        // dracoLoader.setDecoderPath( '/examples/js/libs/draco/' );
        // loader.setDRACOLoader( dracoLoader );
    
        loader.load(
            url,
            ( gltf: any ) => { callback(gltf) },
            ( xhr: any ) => {
                console.log( ( xhr.loaded / xhr.total * 100 ) + '% loaded' )
            },
            ( error: any ) => {
                console.log( '[Loader]: something went wrong while loading', error, url )
            }
        )
    },
    obj: ( props: { mtl: string, obj: string }, callback: Function ) => {
        new MTLLoader()
        .load( props.mtl, ( materials ) => {
            materials.preload()
            console.log('materials', materials)
            new OBJLoader()
                .setMaterials( materials )
                .load( props.obj, ( object ) => {
                            // (object.children[0] as THREE.Mesh).material = material
                            console.log(object)
                            // object.traverse(function (child) {
                            //     if ((child as THREE.Mesh).isMesh) {
                            //         (child as THREE.Mesh).material = material
                            //     }
                            // })

                    callback( object )  
                }, onProgress )
        } )

        const onProgress = function ( xhr ) {
            if ( xhr.lengthComputable ) {
                const percentComplete = xhr.loaded / xhr.total * 100
                console.log( Math.round( percentComplete ) + '% downloaded' )
            }
        }
    }
}